export var toError = function (err) { return err instanceof Error ? err : new Error("".concat(err)); };
